import { TOGGLE_IDUSTRY, SET_POPUP, TOGGLE_ALL, TOGGLE_INDUSTRY_BY_NAME } from './actions';
import { GREY300 } from '../colors';
import { CAT_NAMES } from './mapDataMap';

export const TOOLTIP1 = 'Kartogrāfiskā piesaiste veikta “Jāņa sētā”, pamatojoties uz Latvijas Valsts arhīvā veidoto deportēto Latvijas iedzīvotāju sarakstu un tajā norādītajām vēsturiskajām aresta vietas adresēm';

const DefaultState = {
	updateTime: Date.now(),
	activeInduestries: [], //[[0, 0], [0, 1], [0, 2], [0, 3], [0, 4], [0, 5], [0, 6], [0, 7], [0, 8]], //examples: [ [0] - 'Lauksaimniecība', [1, 3] - Vieglā rūpniecība ]
	activePopupData: [],
	active: true, //if any of categories is active, then true (for faster check if this module is active)
	data: [
		{
			name: CAT_NAMES[0],
			id: 'deported_pop',
			active: true,
			tooltip: true, tooltipText: TOOLTIP1,
			style: {fontSize: '1em', color: GREY300, backgroundColor: 'rgb(124,150,151)', borderBottom:'1.5px solid ' + GREY300 },
			textStyle: {color: '#fff'},
			childs: [
				{name: CAT_NAMES[1], id: 'deported_14', textStyle: {color: 'rgba(0, 0, 0, 0.87)'}, tooltip: true, tooltipText: 'Ieskaitot ceļā un izsūtījuma pirmajos mēnešos dzimušos bērnus, tiem norādot vecāku aresta vietas adresi'},
				{name: CAT_NAMES[2], id: 'deported_25', textStyle: {color: 'rgba(0, 0, 0, 0.87)'}, tooltip: true, tooltipText: 'Ieskaitot ceļā un izsūtījuma pirmajos mēnešos dzimušos bērnus, tiem norādot vecāku aresta vietas adresi'},
				{name: CAT_NAMES[3], id: 'deported_other', textStyle: {color: 'rgba(0, 0, 0, 0.87)'}, tooltip: true, tooltipText: 'Ieskaitot ar nāvessodu notiesāto un nošauto “dzimtenes nodevēju” piederīgie, vācieši, jehovieši, bezpavalstnieki'},
			]
		}//,
		//{
		//	name: CAT_NAMES[4],
		//	id: 'events',
		//	active: false,
		//	tooltip: false,
		//	style: {fontSize: '1em', color: GREY300, backgroundColor: 'rgb(208,54,80)', borderBottom:'1.5px solid ' + GREY300 },
		//	textStyle: {color: '#fff'},
		//	childs: [
		//		{name: CAT_NAMES[5], id: 'events_14', textStyle: {color: 'rgba(0, 0, 0, 0.87)'}, tooltip: false},
		//		{name: CAT_NAMES[6], id: 'events_25', textStyle: {color: 'rgba(0, 0, 0, 0.87)'}, tooltip: false},
		//		{name: CAT_NAMES[7], id: 'events_world', textStyle: {color: 'rgba(0, 0, 0, 0.87)'}, tooltip: false},
		//	]
		//}
	]
}

export const getColorMap = state => {
	var colorMap = {};

	recursiveLoop(state.mapData.data, (category) => {
		if (category.alias) {
			colorMap[category.alias] = category.color;

		} else {
			colorMap[category.name] = category.color;
		}
	});

	return colorMap;
}

export const getActiveIndustries = state => {
	const activeInd = [];

	recursiveLoop(state.mapData.data, (categ) => {
		if (typeof categ.active === 'boolean' && categ.active) {
			if (typeof categ.alias !== 'undefined') {
				activeInd.push(categ.alias);

			} else {
				activeInd.push(categ.name);
			}
		}
	});

	return activeInd;
}

export const recursiveLoop = (data, cb, depth, parent) => {
	if (depth > 10) {
		throw new('ERROR: max recursive depth!');
	}

	if (typeof depth == 'number') {
		depth++;

	} else {
		var depth = 0;
	}

	for (var i = 0, len = data.length; i < len; i++) {
		cb(data[i], depth, i, parent);

		if (typeof data[i].childs === 'object') {
			recursiveLoop(data[i].childs, cb, depth, data[i]);
		}
	}
}

export const isActiveByName = (name, state) => {
	var data = state.mapData.data;

	for (var i = data.length - 1; i >= 0; i--) {
		if (data[i] === name) {
			return;
		}
	}
}

export const getSubIndustries = (state) => {
	var categories = [];

	for (var i = state.data.length - 1; i >= 0; i--) {
		var childs = state.data[i].childs;

		for (var n = childs.length - 1; n >= 0; n--) {
			var childs = childs[n];
			categories.push(childs.name);
		}
	}

	return categories;
}

const toggleAll = (newstate, bolActive) => {
	recursiveLoop(newstate.data, (entry, depth, i) => {
		if (depth < 2) {
			entry.active = bolActive;

			if (typeof entry.childs === 'object') { //array
				entry.childs = [...entry.childs];
			}

		} else {
			if (!bolActive) {
				entry.active = bolActive;
			}
		}
	});

	newstate.active = bolActive;
	return newstate;
}

const mapData = (state = DefaultState, action) => {
	switch (action.type) {
		case TOGGLE_INDUSTRY_BY_NAME:
			const toggle = true;
			const newstate = {...state};
			const activeNames = action.data;

			recursiveLoop(state.data, (entry, depth, i, parent) => {
				if (typeof entry.name !== 'undefined' && activeNames.indexOf(entry.name) > -1) {
					entry.active = !entry.active;

					if (entry.active) {
						if (depth === 2) {
							parent.active = false;

						} else if (depth === 1) {
							recursiveLoop(entry.childs, (entry) => {
								entry.active = false;
							})
						}
					}

				} else {
					if (typeof toggle === 'undefined') {
						entry.active = false;
					}
				}
			});

			recursiveLoop(state.data, (entry, depth) => {
				if (typeof entry.name !== 'undefined' && activeNames.indexOf(entry.name) === -1) {
					entry.active = false;
				}
			});

			var someActive = false;
			recursiveLoop(newstate.data, (entry) => {
				if (entry.active) {
					someActive = true;
				}
			});

			newstate.active = someActive;
			return newstate;

		case TOGGLE_IDUSTRY:
			var newState = Object.assign({}, state);

			var toggleItem = action.data;
			var prevToggleItemState;

			if (toggleItem.parent === -1) {
				prevToggleItemState = newState.data[toggleItem.current].active;
				newState = toggleAll(Object.assign({}, state), false);

				if (prevToggleItemState) {
					newState.data[toggleItem.current].active = false;
					newState.active = false;

				} else {
					newState.data[toggleItem.current].active = true;
					newState.active = true;
				}

			} else {
				prevToggleItemState = newState.data[toggleItem.parent].childs[toggleItem.current].active;
				newState = toggleAll(Object.assign({}, state), false);

				if (prevToggleItemState) {
					newState.data[toggleItem.parent].childs[toggleItem.current].active = false;
					newState.active = false;

				} else {
					newState.data[toggleItem.parent].childs[toggleItem.current].active = true;
					newState.active = true;
				}
			}

			return newState;

		case SET_POPUP:
			return Object.assign({}, state, {activePopupData: action.data});

		case TOGGLE_ALL:
			var someActive = false;

			recursiveLoop(state.data, (entry) => {
				if (entry.active) {
					someActive= true;
				}
			});

			if (someActive) {
				var newstate = toggleAll(Object.assign({}, state), false);

			} else {
				var newstate = toggleAll(Object.assign({}, state), true);
			}

			return newstate;

		default:
			return state;
	}
}

export {mapData}



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/mapData/reducer.js